import i18n from "@/plugins/i18n";


const usertypes = {
  //inhouse users
  1: {
    id: 1,
    text: i18n.t("servicesystem.common_objects.user_types.admin"),
    pluraltext: i18n.t("servicesystem.common_objects.user_types.admins"),
    color: "primary",
    icon: "$administrator",
    sortOrder: 1,
  },
  2: {
    id: 2,
    text: i18n.t("servicesystem.common_objects.user_types.technician"),
    pluraltext: i18n.t("servicesystem.common_objects.user_types.technicians"),
    color: "tertiary",
    icon: "$technician",
    sortOrder: 2,
  },

  //external users
  3: {
    id: 3,
    text: i18n.t("servicesystem.common_objects.user_types.subcontractor"),
    pluraltext: i18n.t("servicesystem.common_objects.user_types.subcontractors"),
    color: "warning",
    icon: "$subcontractor",
    externalWorker: true,
    sortOrder: 3,
  },
  5: {
    id: 5,
    text: i18n.t("servicesystem.common_objects.user_types.partner"),
    pluraltext: i18n.t("servicesystem.common_objects.user_types.partners"),
    color: "secondary",
    icon: "$partner",
    externalWorker: true,
    sortOrder: 4,
  },

  //customer users
  4: {
    id: 4,
    text: i18n.t("servicesystem.common_objects.user_types.customer_manager"),
    pluraltext: i18n.t("servicesystem.common_objects.user_types.customer_managers"),
    color: "quaternary",
    icon: "$customer_manager",
    endCustomer: true,
    sortOrder: 5,
  },
  6: {
    id: 6,
    text: i18n.t("servicesystem.common_objects.user_types.customer_employee"),
    pluraltext: i18n.t("servicesystem.common_objects.user_types.customer_employees"),
    color: "senary",
    icon: "$customer_employee",
    endCustomer: true,
    sortOrder: 6,
  },
};


export default {
  data: () => ({

  }),

  methods: {
    getUserTypeName(id, plural) {
      var name = i18n.t("servicesystem.common_objects.user_types.unknown");
      var propperty = plural ? "pluraltext" : "text";
      if (usertypes[id]) { name = usertypes[id][propperty] }
      return name;
    },

    getUserTypeColor(id) {
      var color = "warning";
      if (usertypes[id]) { color = usertypes[id].color; }
      return color;
    },

    getUserTypeIcon(id) {
      var icon = "mdi-account-question";
      if (usertypes[id]) { icon = usertypes[id].icon; }
      return icon;
    },

    getUserTypeIsNotCustomer(id) {
      return usertypes[id]?.endCustomer != true;
    },
  },

  computed: {
    usertypes() {
      return this.lisenceFilteredUserTypes
    },

    sortedUserTypes() {
      return Object.values(this.usertypes).sort((a, b) => a.sortOrder - b.sortOrder)
    },

    notCustomerUserTypes() {
      return Object.values(this.usertypes).filter(x => x.endCustomer != true);
    },

    customerUserTypes() {
      return Object.values(this.usertypes).filter(x => x.endCustomer == true);
    },

    lisenceFilteredUserTypes() {
      var copy = Object.assign([], usertypes);
      if (!this.PartnerPortalLicense) {
        delete copy[5];
      }
      if (!this.CustomerPortalLicense) {
        copy = copy.filter(x => x.endCustomer != true);
      }
      return copy;
    },
  },
}